import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formMaxWidth } from '../constants/general-info-constants';
import {
  getBurnSupervisor,
  postBurnSupervisor
} from '../../../../../../../actions/rof-burns/01-project-info/01-general-info';
import GeneralInfoForm from '../shared-components/GeneralInfoForm';
import tooltips from '../../../../../../../store/tooltips';

const defaultFormState = {
  isTrained: '',
  supervisorName: '',
  supervisorInfo: '',
}

export default function BurnSupervisor({ projectId, selectedCategory }) {
  const dispatch = useDispatch()
  const [formState, setFormState] = useState(defaultFormState)
  const [formErrors, setFormErrors] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const burnSupervisorData = useSelector((state) => (state.generalInfoReducer.burnSupervisor?.data));

  useEffect(() => {
    handleFormErrorReset()
    dispatch(getBurnSupervisor(projectId))
  }, [selectedCategory, projectId])

  useEffect(() => {
    if (burnSupervisorData)
      setFormState({
        // handle boolean logic for backend
        isTrained: burnSupervisorData?.is_trained === true ? 'yes' : burnSupervisorData?.is_trained === false ? 'no' : '',
        supervisorName: burnSupervisorData?.supervisor_name,
        supervisorInfo: burnSupervisorData?.supervisor_info,
      })
    else {
      setFormState(defaultFormState)
    }

  }, [selectedCategory, projectId, burnSupervisorData])

  const burnSupervisorQuestions = (formState) => {
    const { isTrained, supervisorName, supervisorInfo } = formState
    const defaultQuestions = [
      {
        type: 'radio',
        fieldId: 'isTrained',
        text: 'Is a trained contractor team managing the process on site?',
        value: isTrained,
        tooltip: tooltips.burnSupervisorQ1,
      },
    ]
    const optionalQuestions = [
      {
        type: 'text',
        fieldId: 'supervisorName',
        text: 'Please detail the name of the burn supervisor, and their company/organization:',
        value: supervisorName,
        placeholder: 'Supervisor name and association',
        tooltip: tooltips.burnSupervisorQ2,
      },
      {
        type: 'text',
        fieldId: 'supervisorInfo',
        text: 'Please provide details about their role and relevant experience:',
        value: supervisorInfo,
        placeholder: 'Burn supervisor role and details',
      },
    ]

    return [
      ...defaultQuestions,
      ...(isTrained === 'yes' ? optionalQuestions : isTrained === 'no' ? [{ type: 'No Supervisor' }] : [])
    ]
  }

  const onSubmit = async () => {
    try {
      setIsLoading(true)
      const submissionForm = { ...formState };

      await dispatch(postBurnSupervisor(submissionForm, projectId))
      await dispatch(getBurnSupervisor(projectId))

    } catch (error) {
      setFormErrors(error.message)
    } finally { setIsLoading(false) }
  }

  const setData = (event) => {
    const { name, type } = event.target;
    let value = event.target.value

    if (type === 'file') {
      value = event.target.files[0]
    }

    setFormState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  }

  const handleFormErrorReset = () => {
    setFormErrors(null);
  };

  const questions = burnSupervisorQuestions(formState)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: formMaxWidth }}>
      <Typography variant='h4' sx={{ pb: 2 }}>
        {selectedCategory}
      </Typography>
      <GeneralInfoForm
        formObjectArray={questions}
        formState={formState}
        formErrors={formErrors}
        isLoading={isLoading}
        onChange={setData}
        onSubmit={onSubmit} />
    </Box>
  )
}
